const API_BASE_URL = process.env.NODE_ENV === "production"
  ? "https://api.inshallah.network"
  : "http://localhost:3001";
const WEBSITE_BASE_URL = "https://goldsand.fi";
const APPSTORE_LINK = "https://apps.apple.com/us/app/goldsand-app/id6754749567";
const APP_SCHEME = "goldsand";
const ANDROID_PACKAGE = "com.inshallah.goldsand";
const PLAYSTORE_LINK = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;

export {
  API_BASE_URL,
  WEBSITE_BASE_URL,
  APPSTORE_LINK,
  PLAYSTORE_LINK,
  APP_SCHEME,
  ANDROID_PACKAGE
};
